const cookies = require('js-cookie');
const activeCookieName = 'bw_active';

function cookieManager() {
    this.getActive = function () {
        return getJsonCookie(activeCookieName);
    };

    this.setActive = function (elem) {
        var id = elem?.attr('id');
        if (!id) return; // we don't have an id (or elem), get out
        
        var active = this.getActive();
        // do we want to set/unset? or always set (on/off -- 1/0)?
        // unsetting keeps the cookie smaller at least
        if (elem.is(':hidden')) {
            console.log('hidden');
            // hiding- unset
            delete active[id];
        } else {
            console.log('visible');
            // value could be anything (just looking for key)
            active[id] = 1;
        }
        setJsonCookie(activeCookieName, active);
    };

    function getCookie(name, defaultVal = '') {
        const cookie = cookies.get(name);
        return cookie ?? defaultVal;
    }
    function getJsonCookie(name, defaultVal = {}) {
        const cookie = getCookie(name, JSON.stringify(defaultVal));
        if (cookie) return JSON.parse(cookie);
    }
    function setCookie(name, value, exp = 7, path = '/') {
        cookies.set(name, value, { expires: exp, path: path, sameSite: 'None', secure: true });
    }
    function setJsonCookie(name, value, exp = 7, path = '/') {
        setCookie(name, JSON.stringify(value), exp, path );
    }
}

module.exports = cookieManager;